// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "biWebStatic/css/" + chunkId + "." + {"8":"9bd65aa8","653":"fb97ccba"}[chunkId] + ".css";
};